import { useEffect } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getLocationTrackingData, resetAllState } from "../../features/topPagesMap/topPagesMapSlice"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import TrackingMapLeftSide from "../../components/topPagesMap/tracking/TrackingMapLeftSide"
import { showModal } from "../../features/modal/modalSlice"
import {handleActiveSelect} from "../../features/layout/layoutSlice" 
import TrackingMapWideMap from "../../components/topPagesMap/tracking/TrackingMapWideMap"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import connectionOnTracking from "../../utils/signalR/connectionOnTracking"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 100%;
        height: 100vh;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        overflow: hidden;

        .content{
            width: 100%;
            height: 100vh;
            display: flex;
        }
    }
`
const OpenLocationTracking = () => {

    const dispatch = useDispatch()
    const { rId } = useParams();


    const {
      isLoadingGetLocationTrackingData,
      trackingLocationData,
      trackingDatalocationList,
    } = useSelector(state => state.topPagesMap)


    useEffect(() => {
        if(rId){
            dispatch(getLocationTrackingData(rId))
            localStorage.setItem("shareId", rId)
        }
    },[rId])
    

    useEffect(() => {
        connectionOnTracking()
      },[])


    useEffect(()=> {

    return () => {
        dispatch(resetAllState())
        }
    },[])



  return (
    <Container onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            {
                (trackingDatalocationList?.length > 0 && !isLoadingGetLocationTrackingData) ?
                    <>
                        <TrackingMapLeftSide />
                        <TrackingMapWideMap/>
                    </>
                : 
                <SmallSpinner size={"60px"} color={"#fff"} borderSize="6px" bgColor={"#E85446"}/>
            }
        </div>
    </div>
</Container>
  )
}

export default OpenLocationTracking